import { lazy } from 'react';

const MarketingMaterials = lazy(() => import('../pages/MarketingMaterials'));

const marketingMaterialRoute = {
  public: [],
  auth: [
    {
      name: 'marketing_materials',
      path: '/marketing-materials',
      permissions: [
        'KASM',
        'KASROM',
        'KASOM',
        'KASH',
        'SAM',
        'RSM',
        'NSM-SPARTAN',
        'admin',
        'PM',
        'GPM',
        'COO',
        'EXECUTIVE',
      ],
      component: MarketingMaterials,
    },
  ],
};

export default marketingMaterialRoute;
